import { InventoryMeterMountType, OutputTechnology } from '@enmon/commons/lib/tools';
import { OtherDeviceCategory, MeasuringCurrentTransformer, Orientation } from '@enmon/commons/lib/shared/meter';
import { MeterAccessibility } from '@enmon/commons/lib/enmon';

export enum InventoryMeterFilterActivationStatus {
  Deactivated,
  Activated,
}

export const measuringCurrentTransformerTranslated: Record<MeasuringCurrentTransformer, string> = {
  [MeasuringCurrentTransformer.MCT1]: '1/5 A',
  [MeasuringCurrentTransformer.MCT5]: '5/5 A',
  [MeasuringCurrentTransformer.MCT10]: '10/5 A',
  [MeasuringCurrentTransformer.MCT12p5]: '12.5/5 A',
  [MeasuringCurrentTransformer.MCT15]: '15/5 A',
  [MeasuringCurrentTransformer.MCT20]: '20/5 A',
  [MeasuringCurrentTransformer.MCT25]: '25/5 A',
  [MeasuringCurrentTransformer.MCT30]: '30/5 A',
  [MeasuringCurrentTransformer.MCT40]: '40/5 A',
  [MeasuringCurrentTransformer.MCT50]: '50/5 A',
  [MeasuringCurrentTransformer.MCT60]: '60/5 A',
  [MeasuringCurrentTransformer.MCT70]: '70/5 A',
  [MeasuringCurrentTransformer.MCT75]: '75/5 A',
  [MeasuringCurrentTransformer.MCT80]: '80/5 A',
  [MeasuringCurrentTransformer.MCT100]: '100/5 A',
  [MeasuringCurrentTransformer.MCT125]: '125/5 A',
  [MeasuringCurrentTransformer.MCT150]: '150/5 A',
  [MeasuringCurrentTransformer.MCT200]: '200/5 A',
  [MeasuringCurrentTransformer.MCT250]: '250/5 A',
  [MeasuringCurrentTransformer.MCT300]: '300/5 A',
  [MeasuringCurrentTransformer.MCT400]: '400/5 A',
  [MeasuringCurrentTransformer.MCT500]: '500/5 A',
  [MeasuringCurrentTransformer.MCT600]: '600/5 A',
  [MeasuringCurrentTransformer.MCT750]: '750/5 A',
  [MeasuringCurrentTransformer.MCT800]: '800/5 A',
  [MeasuringCurrentTransformer.MCT1000]: '1000/5 A',
  [MeasuringCurrentTransformer.MCT1250]: '1250/5 A',
  [MeasuringCurrentTransformer.MCT1500]: '1500/5 A',
  [MeasuringCurrentTransformer.MCT1600]: '1600/5 A',
  [MeasuringCurrentTransformer.MCT2000]: '2000/5 A',
  [MeasuringCurrentTransformer.MCT2500]: '2500/5 A',
  [MeasuringCurrentTransformer.MCT3000]: '3000/5 A',
};

export const inventoryMeterAccessibilityTranslated: Record<MeterAccessibility, string> = {
  [MeterAccessibility.Good]: 'Dobrá',
  [MeterAccessibility.Bad]: 'Špatná',
  [MeterAccessibility.Tenant]: 'U nájemce (nutné ohlášení)',
  [MeterAccessibility.Basement]: 'Sklep',
  [MeterAccessibility.Ceiling]: 'V podhledu',
  [MeterAccessibility.Shaft]: 'V šachtě',
  [MeterAccessibility.FloodedShaft]: 'V zatopené šachtě',
  [MeterAccessibility.High]: 'Vysoko (více než 2 metry)',
  [MeterAccessibility.FairlyHigh]: 'Docela vysoko (více než 3 metry)',
  [MeterAccessibility.VeryHigh]: 'Velmi vysoko (více než 5 metrů)',
};

export const orientationTranslated: Record<Orientation, string> = {
  [Orientation.Horizontal]: 'Horizontální',
  [Orientation.VerticalFlowUp]: 'Vertikální - směr proudění ↑',
  [Orientation.VerticalFlowDown]: 'Vertikální - směr proudění ↓',
};

export const inventoryMeterMountTypeTranslated: Record<InventoryMeterMountType, string> = {
  [InventoryMeterMountType.Free]: 'Neosazen',
  [InventoryMeterMountType.MountedFree]: 'Osazen - volný',
  [InventoryMeterMountType.MountedOccupied]: 'Osazen - obsazený',
};

export const outputTechnologyTranslated: Record<OutputTechnology, string> = {
  [OutputTechnology.Impulse]: 'Impulz',
  [OutputTechnology.MBus]: 'M-Bus',
  [OutputTechnology.WirelessMBus]: 'Wireless M-Bus',
  [OutputTechnology['Modbus-RS485']]: 'Modbus RS485',
  [OutputTechnology['Modbus-RS232']]: 'Modbus RS232',
  [OutputTechnology.Led]: 'LED',
  [OutputTechnology['IEC62056-Optical']]: 'IEC Optical',
  [OutputTechnology['IEC62056-RS485']]: 'IEC RS485',
};

export const otherDeviceCategoryTranslated: Record<OtherDeviceCategory, string> = {
  [OtherDeviceCategory.Gateway]: 'Gateway',
  [OtherDeviceCategory.LoRaGateway]: 'LoRa Gateway',
  [OtherDeviceCategory.LoRaGatewayPowerSupply]: 'LoRa Gateway power supply',
  [OtherDeviceCategory.Thermometer]: 'Teploměr',
  [OtherDeviceCategory.AirQualitySensor]: 'Senzor kvality vzduchu',
  [OtherDeviceCategory.Antenna]: 'Anténa',
  [OtherDeviceCategory.ExteriorTemperature]: 'Venkovní teplota',
  [OtherDeviceCategory.InteriorTemperature]: 'Vnitřní teplota',
  [OtherDeviceCategory.WaterLevel]: 'Hladina vody',
};
